<template>
  <div class="flex flex-col gap-4">
    <div role="tablist" class="tabs tabs-border bg-base-100 p-2 shadow-sm">
      <RouterLink
        v-for="t in sub_tabs"
        :key="t.route_name"
        role="tab"
        :class="
          twMerge(
            'tab transition-all duration-200',
            $route.name?.toString().startsWith(t.route_name) &&
              'tab-active text-primary font-bold',
          )
        "
        :to="{
          name: t.route_name,
        }"
      >
        <span class="flex items-center gap-2">
          <i :class="twMerge(t.ico, 'opacity-80')"></i>
          <span>{{ t.value }}</span>
        </span>
      </RouterLink>
    </div>

    <div class="min-h-0 flex-1">
      <RouterView />
    </div>
  </div>
</template>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";
import { RouterLink, RouterView } from "vue-router";

const sub_tabs = [
  {
    value: "Thu thập thông tin",
    route_name: "ClientRecon",
    ico: "fa-solid fa-magnifying-glass",
  },
  {
    value: "Dò mật khẩu",
    route_name: "ClientBruteForce",
    ico: "fa-solid fa-key",
  },
  {
    value: "Network Scan",
    route_name: "ClientNmap",
    ico: "fa-solid fa-network-wired",
  },
];
</script>

<style scoped>
.tab-active {
  border-bottom-width: 2px;
}
</style>
